import { Flex, Modal } from 'antd'
import { ReactNode, useMemo } from 'react'
import Masonry from '../Masonry'
import s from './s.module.css'
import Text from '@/components/typography/Text'
import Title from '@/components/typography/Title'
import { ImageAsset } from '@/types/assets'

interface IChooseImageModalProps {
  isOpen: boolean
  onCancel: () => void
  imagesList: ImageAsset[]
  onSelectImage: (img: ImageAsset | null) => void
  title: ReactNode
  subtitle?: ReactNode
  selectedImage?: string | null
}

const columnCount = 3

function ChooseImageModal({
  isOpen,
  onCancel,
  onSelectImage,
  imagesList,
  selectedImage,
  title,
  subtitle,
}: IChooseImageModalProps) {
  const defaultImageIndex = imagesList.findIndex(img => img.is_default)
  const images = useMemo(() => {
    let temp: ImageAsset[] = []

    if (defaultImageIndex === -1) {
      temp = imagesList
    } else {
      temp = imagesList.slice(0, defaultImageIndex).concat(imagesList.slice(defaultImageIndex + 1))
    }

    temp = temp.sort((a, b) => Number(b.is_custom) - Number(a.is_custom))

    if (defaultImageIndex > -1) {
      temp.unshift(imagesList[defaultImageIndex])
    }

    return temp
  }, [defaultImageIndex, imagesList])

  return (
    <Modal open={isOpen} onCancel={onCancel} footer={null} className={s.modal} classNames={{ content: s.modalContent }}>
      <Flex vertical gap={24}>
        <Flex vertical gap={4} className={s.header}>
          <Title level={4} fontType="header" fontSize={4}>
            {title}
          </Title>
          {subtitle ? <Text fontType="description">{subtitle}</Text> : null}
        </Flex>
        <div className={s.content}>
          <Masonry
            imagesList={images}
            selectedImages={selectedImage ? [selectedImage] : []}
            columnCount={columnCount}
            sizes="160px"
            controls={{
              onSelect: onSelectImage,
            }}
            selectType="border"
          />
        </div>
      </Flex>
    </Modal>
  )
}

export default ChooseImageModal
